import {
  AC_TLGeo_addRoleForUser_Request,
  AC_TLGeo_addRoleForUser_Response,
  AC_TLGeo_deleteRoleForUser_Request_Query,
  AC_TLGeo_deleteRoleForUser_Response,
  AC_TLGeo_getMyPermissions_Response,
  AC_TLGeo_getMyRoles_Response,
} from '../services/access_control/AC_Tlgeo';
import { getAxiosInstance } from '../../react/utils/networkUtil';

export const remote_ACLTLGeo_getMyRoles = async (): Promise<AC_TLGeo_getMyRoles_Response> => {
  const response = await getAxiosInstance().get('/api/acl-tlgeo-ext/my-roles');
  const data: any = response.data;
  return data;
};

export const remote_ACLTLGeo_getMyPermissions = async (): Promise<AC_TLGeo_getMyPermissions_Response> => {
  const response = await getAxiosInstance().get('/api/acl-tlgeo-ext/my-permissions');
  const data: any = response.data;
  return data;
};

export const remote_ACLTLGeo_addRoleForUser = async (
  request: AC_TLGeo_addRoleForUser_Request,
): Promise<AC_TLGeo_addRoleForUser_Response> => {
  const response = await getAxiosInstance().post('/api/acl-tlgeo-ext/roles', request);
  const data: any = response.data;
  return data;
};

export const remote_ACLTLGeo_deleteRoleForUser = async (
  request: AC_TLGeo_deleteRoleForUser_Request_Query,
): Promise<AC_TLGeo_deleteRoleForUser_Response> => {
  const response = await getAxiosInstance().delete('/api/acl-tlgeo-ext/roles', {
    params: request,
  });
  const data: any = response.data;
  return data;
};

export const ACLTLGeoAPIs = {
  remote_ACLTLGeo_getMyRoles,
  remote_ACLTLGeo_getMyPermissions,
  remote_ACLTLGeo_addRoleForUser,
  remote_ACLTLGeo_deleteRoleForUser,
};
